import { setRouteClean } from "../actions/user";
import store from "../store";

export async function cleanRoute(value: boolean) {
  store.dispatch(setRouteClean(value));

  // waiting for the clean route to be updated
  await new Promise((res) => setTimeout(res, 1500));
}
